import { IconButton } from '@material-ui/core';
import styled from 'styled-components';

export const RemoveButton = styled(IconButton)`
  height: 40px;
  width: 40px;
`;

export default RemoveButton;
